<template>
<div class="chapter">
<div class="inner_page">
<div class="galley">
<div class="frontmatter TableOfContents">
<p id="rw-p_110259-00001"><a id="pb-rw_xv">
</a></p><a id="pb-rw_xv">
<div class="title-block" id="rw-title-block_110259-00001">
<h1>Contents</h1>
</div>
</a><div class="block toc" id="rw-block-toc_110259-00001"><a id="pb-rw_xv">
</a><p><a id="pb-rw_xv"><span class="sc"></span></a><a href="#/9781847674951_chapter_01">ABBREVIATIONS USED BY SCOTT</a>
</p>
<div class="paras leading-line" id="rw-paras-leading-line_110259-00001"> </div>
<p class="fp"><span class="sc"><a href="#/9781847674951_chapter_02">ABBREVIATIONS USED IN THE NOTES</a></span>
</p>
<div class="paras leading-line" id="rw-paras-leading-line_110259-00002"> </div>
<p class="fp"><span class="sc"><a href="#/9781847674951_introduction">INTRODUCTION</a></span>
</p>
<p><a href="#/9781847674951_introduction#rw-h2_110262-00001">Scott’s Edinburgh: The Changing City</a></p>
<p><a href="#/9781847674951_introduction#rw-h2_110262-00002">The Law</a></p>
<p><a href="#/9781847674951_introduction#rw-h2_110262-00003">Abbotsford</a></p>
<p><a href="#/9781847674951_introduction#rw-h2_110262-00004">The Financial Crash</a></p>
<p><a href="#/9781847674951_introduction#rw-h2_110262-00005">The Arbitration</a></p>
<p><a href="#/9781847674951_introduction#rw-h2_110262-00006">Political Affairs</a></p>
<p><a href="#/9781847674951_introduction#rw-h2_110262-00007">The People of the <i>Journal</i></a>
</p>
<div class="paras leading-line" id="rw-paras-leading-line_110259-00003"> </div>
<p class="fp"><span class="sc"><a href="#/9781847674951_chapter_03">THE EVENTS OF THE <i>JOURNAL</i></a></span>
</p>
<div class="paras leading-line" id="rw-paras-leading-line_110259-00004"> </div>
<p class="fp"><a href="#/9781847674951_part_01">THE JOURNAL</a></p>
<div class="paras leading-line" id="rw-paras-leading-line_110259-00005"> </div>
<p class="fp"><span class="sc"><span href="#/9781847674951_chapter_12" title="Link target outside of Sample">ADDITIONAL NOTES</span></span>
</p>
<div class="paras leading-line" id="rw-paras-leading-line_110259-00006"> </div>
<p class="fp"><span class="sc">APPENDICES</span>
</p>
<p><span href="#/9781847674951_appendix" title="Link target outside of Sample"><span class="sc">A</span>. Chronology of the Life of Sir Walter Scott</span>
</p>
<p><span href="#/9781847674951_appendix_02" title="Link target outside of Sample"><span class="sc">B</span>. Country Houses of the <i>Journal</i> and their Owners</span>
</p>
<p><span href="#/9781847674951_appendix_03" title="Link target outside of Sample"><span class="sc">C</span>. Edinburgh Addresses</span>
</p>
<p><span href="#/9781847674951_appendix_04" title="Link target outside of Sample"><span class="sc">D</span>. Politics in the <i>Journal</i></span>
</p>
<p><span href="#/9781847674951_appendix_05" title="Link target outside of Sample"><span class="sc">E</span>. Dating</span>
</p>
<p><span href="#/9781847674951_appendix_06" title="Link target outside of Sample"><span class="sc">F</span>. Silent Corrections</span>
</p>
<p><span href="#/9781847674951_appendix_07" title="Link target outside of Sample"><span class="sc">G</span>. Memoranda</span>
</p>
<div class="paras leading-line" id="rw-paras-leading-line_110259-00007"> </div>
<p class="fp"><span class="sc"><span href="#/9781847674951_index" title="Link target outside of Sample">INDEX</span></span>
</p>
</div>
<p class="fp" id="rw-p_110259-00002"><a id="pb-rw_xvi">
</a></p><a id="pb-rw_xvi">
</a></div><a id="pb-rw_xvi">
</a></div><a id="pb-rw_xvi">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781847674951_tableofcontents.vue?9dc54edc